import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Tooltip,
    TablePagination,
    TextField,
    Box,
    TableSortLabel,
  } from "@mui/material";
  import { styled } from "@mui/material/styles";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: "2px", // reduce cell padding
  }));

export  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // height: "30px", // reduce row height
    backgroundColor: theme.palette.action.hover, // alternate row color
  }));
  
export const HeaderTableCell = styled(TableCell)(({ theme }) => ({
    fontWeight: "bold",
    backgroundColor: "#9e9e9e", // header background color
  }));
  export const SortHeaderTableCell = styled(TableSortLabel)(({ theme }) => ({
    fontWeight: "bold",
    backgroundColor: "#9e9e9e", // header background color
  }));